'use client';

import { MainTitle } from '@repo/ui';
import { useCallback, useEffect, useRef, useState } from 'react';

import { ChatTextarea } from '@/app/_components/chat-content/ChatTextarea';
import { StickyChat } from '@/app/_components/chat-content/StickyChat';

export const MainChat = () => {
  const mainChat = useRef<HTMLDivElement>(null);
  const [isShowStickyChat, setIsShowStickyChat] = useState(false);

  const onIntersect = useCallback(async ([entry]: IntersectionObserverEntry[]) => {
    if (!entry) return;

    setIsShowStickyChat(!entry.isIntersecting);
  }, []);

  useEffect(() => {
    const observer: IntersectionObserver = new IntersectionObserver(onIntersect);
    if (mainChat.current) {
      observer.observe(mainChat.current);
    }
    return () => observer && observer.disconnect();
  }, [onIntersect]);

  return (
    <>
      <div ref={mainChat} className={'py-[55px] w-full container-medium lg:container-large'}>
        <MainTitle
          title={
            <div>
              <div>세무·법률·노무,</div>
              <div className={'highlight-gradient sena-dark shimmer will-change-transform'}>무엇이든 편하게 물어보세요</div>
            </div>
          }
          className={'text-center'}
          size={'large'}
        />
        <div className={'pb-spacious-large w-full max-w-[597px] mx-auto'}>
          <ChatTextarea location={'top'} />
        </div>
      </div>
      {<StickyChat viewMode={isShowStickyChat ? 'fixed' : 'hidden'} scrollButtonDirection={'top'} />}
    </>
  );
};
